import axios from 'axios'


const basUrl = "web-api/"
const ossImgUrl = "oss-img-api/"
// 通用公用方法
const reqGet = (url, params) => {
  // console.log(url);
  let t = new Date().getTime()
  if (url.indexOf('?') > -1) {
    url = url + "&timestamp=" + t
  } else {
    url = url + "?timestamp=" + t
  }
  return axios({
    method: "get",
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params,
    traditional: true,
    cache: false,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  })
    .then(res => {
      return res.data
    })
    .catch(() => {
      // router.push('/login');
    })
}
const reqPost = (url, params) => {
  return axios({
    method: "post",
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params
  })
    .then(res => {
      // console.log(res)
      return res.data
    })
    .catch((err) => {
    })
}
export {
  basUrl,
  ossImgUrl,
  reqGet,
  reqPost
}



// WEBPACK FOOTER //
// ./src/api/index.js